// Shared enquiry status definitions used by Admin pages
export const STATUS_OPTIONS = [
  { value: "new", label: "New", className: "bg-brand-orange/15 text-brand-orange border-brand-orange/30" },
  { value: "contacted", label: "Contacted", className: "bg-blue-100 text-blue-800 border-blue-200" },
  { value: "follow_up", label: "Follow up", className: "bg-amber-100 text-amber-800 border-amber-200" },
  { value: "converted", label: "Converted", className: "bg-emerald-100 text-emerald-800 border-emerald-200" },
  { value: "not_interested", label: "Not interested", className: "bg-zinc-100 text-zinc-700 border-zinc-200" },
];

export function getStatusMeta(value) {
  return STATUS_OPTIONS.find((s) => s.value === value) || STATUS_OPTIONS[0];
}
